export function tableAdaptation() {
    const $tableAll = $(".table-adaptive");

    $tableAll.each((index, table) => {
        const trArr = $(table).find("tbody tr");
        const thArr = $(table).find("th");

        trArr.each((index, tr) => {
            const tdArr = $(tr).find("td");
            tdArr.each((index, td) => {
                if (thArr[index]) {
                    $(td).attr("data-label", $(thArr[index]).text());
                }
            });
        });
    });



}


// WEBPACK FOOTER //
// ./assets/js/modules/tableAdaptation.js